import { ShowRead } from '@generated/types'

export function buildShowRichPagePath(slug: string): string {
  return `/s/${slug}`
}

export function buildEnabledShowRichPagePath(
  show: Partial<Pick<ShowRead, 'rich_page_enabled' | 'slug'>> | null | undefined,
): string | null {
  return show?.rich_page_enabled && show.slug ? buildShowRichPagePath(show.slug) : null
}
